<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">{{ 'app_footer.general_request' | translate }}</h4>
    <button type="button" class="close" (click)="bsModalRef.hide()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form action="" method="post" enctype="multipart/form-data" class="form-horizontal">
      <div class="from-group row">
        <label class="col-md-3 form-control-label">{{ 'app_footer.your_email' | translate }}</label>
        <label class="col-md-9 form-control-label text-muted">{{ identity.app_membership.app_user_email }}</label>
      </div>
      <div class="form-group row">
        <label class="col-md-3 form-control-label" for="textarea-input">{{ 'app_footer.message' | translate }}</label>
        <div class="col-md-9">
          <textarea
            id="textarea-input"
            name="textarea-input"
            rows="6"
            class="form-control"
            [placeholder]="'app_footer.report_bug_give_feedback' | translate"
            [(ngModel)]="message"></textarea>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="bsModalRef.hide()">
      {{ 'app_footer.close' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="sendFeedback()">{{ 'app_footer.send' | translate }}</button>
  </div>
</div>
